<template lang="pug">
#batch_actions_wrapper(:class="{ in: show }")
  slot
  .actions.ml-auto
    a.select-all(
      href="#"
      data-testid="select-all-activities-button"
      @click.prevent="onSelectAll"
    ) Select all
    a.cancel.valign-middle.ml-15(
      href="#"
      @click.prevent="onCancel"
    )
      i.hi.hi-close.hi-12.text-lighter
</template>

<script>
export default {
  name: 'AppBatchActionsPanel',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    window.document.body.appendChild(this.$el);
  },
  beforeDestroy() {
    this.$el.parentNode?.removeChild?.(this.$el);
  },
  methods: {
    onSelectAll() {
      this.$emit('select-all');
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>
